/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, useMemo } from 'react';
import { FormControlLabel, Card, CardContent } from '@material-ui/core';
import Checkbox from 'components/Checkbox';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import { Field, FieldProps } from 'formik';
import styles from './styles';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import useFeature from 'hooks/useFeature';

const OptInOut: FC = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();
  const { isEnabled } = useFeature();
  const enabled = useMemo(() => isEnabled('optInOut'), [isEnabled]);
  return enabled ? (
    <Card elevation={0} css={styles.card}>
      <CardContent>
        <div css={styles.optInOutText}>{tMdMultiline('optInOut.content')}</div>
        <Field name="optInOut" type="checkbox">
          {(fieldProps: FieldProps) => (
            <FormControlLabel
              id="creditAppOptInOut"
              labelPlacement={'end'}
              css={styles.optInOutLabel}
              control={
                <Checkbox
                  {...fieldProps.field}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  color="primary"
                />
              }
              label={tMdMultiline('optInOut.label')}
            />
          )}
        </Field>
      </CardContent>
    </Card>
  ) : null;
};

export default OptInOut;
